import {Component} from '@angular/core';

@Component({
  selector: 'app-money-white-icon',
  templateUrl: './money-white-icon.component.html'
})
export class MoneyWhiteIconComponent {
}
